module.exports = __webpack_public_path__ + "static/media/family-and-pet.595350c6.jpg";